import { Post, Get, GetSSE } from "domain/infra/data/api";
import CampanhaConstants from "../../infra/data/campanhaConstants";
import { PagarPedidoResponse } from "../../types/pagarPedido/pagarPedidoResponse";
import { PagarPedidoRequest } from "../../types/pagarPedido/pagarPedidoRequest";
import { CampanhaPedidoResgatePagamentoDepositoResponse } from "../../types/pagarPedido/campanhaPedidoResgatePagamentoDepositoResponse";
import { EnviarEmailNotaRepasseRequest } from "../../types/pagarPedido/EnviarEmailNotaRepasseRequest";
import { GerarBoletoResponse } from "../../types/lotePedido/gerarBoletoResponse";
import { DuploFatorRequest } from "../../types/pagarPedido/duploFator";
import ValidationResult from "domain/types/global/validationResult";
import { GerarPixResponse } from "../../types/lotePedido/gerarPixResponse";

export class PagarPedidoService {
  constructor() {

  }
  async Pagar(request: PagarPedidoRequest, dispatchName: string): Promise<PagarPedidoResponse[] | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhaPagarPedido.pagar, request, dispatchName)
  }

  async TentarNovamente(request: PagarPedidoRequest, dispatchName: string): Promise<PagarPedidoResponse[] | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhaPagarPedido.tentarNovamente, request, dispatchName)
  }

  async obterNotaRepasse(campanhaPedidoResgatePagamentoId: number, dispatchName: string): Promise<string | Error> {
    const url = `${CampanhaConstants.apiCampanha.CampanhaPedidoResgate.notaRepasse}?campanhaPedidoResgatePagamentoId=${campanhaPedidoResgatePagamentoId}`;
    return await Get(url, dispatchName);
  }

  async obterBoleto(campanhaPedidoResgatePagamentoId: number, dispatchName: string): Promise<CampanhaPedidoResgatePagamentoDepositoResponse | Error> {
    const url = `${CampanhaConstants.apiCampanha.CampanhaPedidoResgatePagamentoDeposito.getCampanhaPedidoResgatePagamento(campanhaPedidoResgatePagamentoId)}`;
    return await Get(url, dispatchName);
  }
  async enviarCodigoWhatsApp(request: DuploFatorRequest, dispatchName: string): Promise<ValidationResult | Error> {
    const url = `${CampanhaConstants.apiCampanha.DuploFator.enviarZap}`;
    return await Post(url, request, dispatchName);
  }
  async gerarBoleto(campanhaPedidoResgatePagamentoId: number, carteiraId: number, dispatchName: string): Promise<GerarBoletoResponse | Error> {
    const url = `${CampanhaConstants.apiCampanha.CampanhaPedidoResgatePagamentoDeposito.getCampanhaPedidoResgatePagamentoDepositoBoleto(campanhaPedidoResgatePagamentoId, carteiraId)}`;
    return await Post(url, dispatchName);
  }
  async gerarPix(campanhaPedidoResgatePagamentoId: number, carteiraId: number, dispatchName: string): Promise<GerarPixResponse | Error> {
    const url = `${CampanhaConstants.apiCampanha.CampanhaPedidoResgatePagamentoDeposito.getCampanhaPedidoResgatePagamentoDepositoPix(campanhaPedidoResgatePagamentoId, carteiraId)}`;
    return await Post(url, dispatchName);
  }

  async PixCheckSSE(codigoInterno: string): Promise<string | Error> {
    return await GetSSE(`${CampanhaConstants.apiCampanha.CampanhaPedidoResgatePagamentoDeposito.pixCheckSSE(codigoInterno)}`)
  }

  async enviarEmailNotaRepasse(request: EnviarEmailNotaRepasseRequest, loadingName: string): Promise<boolean | Error> {
    try {
      const response = await Post(CampanhaConstants.apiCampanha.CampanhaPedidoResgatePagamentoDeposito.enviarEmail, request, loadingName);

      if (response instanceof Error) {
        return response;
      }

      return true;
    } catch (error) {
      return new Error('Erro ao enviar e-mail da nota de repasse');
    }
  }
}